/**
 * @author gll
 * 功能：单位模块
 */
import { Service } from '@/tools'
export class SkuTagService<T extends TCommodity.SkuTag> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TCommodity.SkuTag}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 模块说明：是否可删除-禁用标签
   * /api/commodity/skuTag/v1/accessible
   */
  accessible = <K extends T['ApiAccessible']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiAccessible', data)
}
